import { useRouteMatch } from 'react-router';

import { TopPanel } from '../../components';
import { MessagesList } from './MessagesList';
import { ContactInfo } from '../../templates';
import { PermissionCheck } from '../../shared';
import { Button, Input } from '../../components';
import { ExternalConversationLink } from '../../templates';
import { useMessagesForContact } from './useMessagesForContact';

type MessagesForContactComponentProps = {
  contactId: string;
};

const MessagesForContactComponent: React.FC<
  MessagesForContactComponentProps
> = ({ contactId }) => {
  const {
    nodes,
    refresh,
    sending,

    chat,
    setChat,
    sendChat,
    reloading,
    initializing,

    contact,
  } = useMessagesForContact(contactId);

  return (
    <div className="flex flex-col gap-y-md w-full">
      <TopPanel
        topLeftContent={
          !!contact && (
            <ExternalConversationLink contactPhone={contact.phone}>
              <ContactInfo
                contact={contact}
                withAdditionalInfo={false}
                className="font-medium text-big truncate h-full"
              />
            </ExternalConversationLink>
          )
        }
        buttons={[
          {
            icon: 'refresh',
            label: 'Refresh',
            onClick: refresh,
            loading: reloading,
          },
        ]}
      />

      <MessagesList initializing={initializing} data={nodes} />
      <PermissionCheck action="manage_outreach_contacts">
        <div className="flex gap-md items-center relative">
          <Input
            multiline
            rows={3}
            value={chat}
            onChange={setChat}
            disabled={!contact || sending}
            placeholder="Type your message as a human representative..."
          />
          <Button
            icon="send"
            className="h-fit"
            loading={sending}
            onClick={sendChat}
            disabled={!chat.trim().length || !contact}
          />
        </div>
      </PermissionCheck>
    </div>
  );
};

const MessagesForContact = () => {
  const {
    params: { id },
  } = useRouteMatch<{ id: string }>();

  return id ? <MessagesForContactComponent contactId={id} /> : null;
};

export default MessagesForContact;
